import { useQuery } from '@tanstack/react-query';

import { fetchCampsForLocation } from '../api/camps';

export default function useCampsQuery(locationId: number) {
  const { data, isLoading, error } = useQuery({
    queryKey: ['camps', locationId],
    queryFn: () => fetchCampsForLocation(locationId),
  });

  return { data, isLoading, error };
}
